import React from 'react';
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
  // ViewStyle,
  // TextStyle,
} from 'react-native';
import Entypo from '@react-native-vector-icons/entypo/static';
import FontAwesome6 from '@react-native-vector-icons/fontawesome6/static';
import { fs, iconSize, s, v } from '../../utils/libs';
import { GTFonts, theme } from '../../theme';

type FontAwesome6SolidIconName = Extract<
  React.ComponentProps<typeof FontAwesome6>,
  { iconStyle: 'solid' }
>['name'];

interface ButtonProps {
  disabled?: boolean;
  fontSize?: number;
  onPress: () => void;
  text: string;
  rippleColor?: string;
  backgroundColor: string;
  height?: number;
  icon?: FontAwesome6SolidIconName | 'lock' | '';
  iconSize?: number;
  opacity?: number;
  width?: number;
  paddingHorizontal?: number;
  borderRadius: number;
  fontFamily?: string;
  loading?: boolean;
  textColor?: string;
  /** When true, button stretches to fill parent width (ignores `width` prop) */
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  disabled,
  fontSize,
  onPress,
  text,
  rippleColor,
  backgroundColor,
  height,
  icon,
  iconSize: iconSizeProp,
  opacity,
  width,
  paddingHorizontal,
  borderRadius,
  fontFamily,
  loading,
  textColor,
  fullWidth,
}) => {
  const touchDisabled = !!disabled || !!loading;
  return (
    <View style={[styles.container, fullWidth && styles.fullWidth]}>
      <TouchableOpacity
        disabled={touchDisabled}
        // android_ripple={{ color: rippleColor, borderless: false, foreground: true }}
        hitSlop={{
          top: v(10),
          bottom: v(10),
          left: s(10),
          right: s(10),
        }}
        onPress={onPress}
        style={[
          styles.button,
          {
            borderRadius: borderRadius,
          },
          {
            backgroundColor: backgroundColor,
            elevation: touchDisabled ? 0 : 1.5,
            height: height,
            width: fullWidth ? undefined : width,
            paddingHorizontal: paddingHorizontal,
            borderColor: backgroundColor,
            opacity: opacity,
          },
          disabled && { backgroundColor: theme.colors.borderGray },
        ]}>
        {icon && icon !== 'lock' ? (
          <FontAwesome6
            name={icon}
            iconStyle="solid"
            style={{ marginRight: s(8) }}
            size={iconSize(iconSizeProp ?? 20)}
            color={textColor || 'white'}
          />
        ) : null}
        <Text
          style={[
            styles.text,
            fontFamily
              ? { fontFamily: fontFamily }
              : { fontFamily: GTFonts.semibold },
            {
              fontSize: fontSize ? fs(fontSize) : fs(20),
              lineHeight: fontSize ? fs(fontSize + 2) : fs(22),
            },
            icon === 'lock' && { paddingLeft: s(5) },
            { color: textColor || 'white' },
          ]}>
          {text}
        </Text>
        {icon && icon === 'lock' ? (
          <Entypo
            name={icon}
            style={{ paddingLeft: s(8) }}
            size={iconSize(iconSizeProp ?? 20)}
            color={textColor || 'white'}
          />
        ) : null}
        {loading ? (
          <ActivityIndicator
            style={{ paddingLeft: s(8) }}
            size="small"
            color={textColor || 'white'}
          />
        ) : null}
      </TouchableOpacity>
    </View>
  );
};
export default Button;

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
  },
  fullWidth: {
    alignSelf: 'stretch',
  },
  button: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  text: {
    fontSize: fs(20),
    // lineHeight: fs(20),
    color: 'white',
  },
});
